import { TablePage } from 'web-mojo';
import { PaymentProcessor, PaymentProcessorList } from '@portal/models/PaymentProcessor.js';

export default class VendingPaymentProvidersPage extends TablePage {
    constructor(options = {}) {
        super({
            title: 'Payment Providers',
            icon: 'bi-bank',
            pageName: 'vending_payment_providers',
            route: 'group/vending/payments',
            permissions: ['manage_payments', 'payments', 'manage_group', 'manage_groups'],
            requiresGroup: true,

            Collection: PaymentProcessorList,

            defaultQuery: {
                group: () => app.activeGroup?.id,
            },

            columns: [
                {
                    label: 'Type',
                    key: 'processor_type',
                    formatter: (val) => {
                        const name = (val || '').charAt(0).toUpperCase() + (val || '').slice(1);
                        return name || '—';
                    },
                },
                {
                    label: 'Currency',
                    key: 'metadata.currency',
                    formatter: "default('USD')",
                },
                {
                    label: 'Default',
                    key: 'is_default',
                    formatter: "yesnoicon('bi-check-circle-fill text-primary', 'bi-dash text-muted')",
                },
                {
                    label: 'Status',
                    key: 'is_active',
                    formatter: (val) => val
                        ? '<span class="badge bg-success">Active</span>'
                        : '<span class="badge bg-secondary">Inactive</span>',
                },
            ],

            clickAction: 'edit',
            searchable: false,
            sortable: true,
            filterable: true,
            paginated: false,
            showRefresh: true,

            tableOptions: {
                striped: true,
                bordered: false,
                hover: true,
                responsive: true,
            },

            contextMenu: [
                { label: 'Edit',        icon: 'bi bi-pencil',       action: 'edit' },
                { label: 'Set Default', icon: 'bi bi-check-circle', action: 'set-default' },
            ],

            tableViewOptions: {
                hideActivePillNames: ['group'],
                addRequiresActiveGroup: true,
                addButtonLabel: 'Add Provider',
                addRequiresActiveGroup: true
            },

            ...options,
        });
    }

    async onActionSetDefault(event, el) {
        const id = el.getAttribute('data-id');
        const processor = this.collection.get(id);
        if (!processor) return;
        const response = await processor.save({ is_default: true });
        if (!response.success || !response.data.status) {
            app.toast.error(response.data?.error || 'Failed to set default');
            return;
        }
        app.toast.success('Default processor updated');
        this.collection.fetch();
    }
}
